import { createSlice, Draft } from "@reduxjs/toolkit";
import { ResponseMetaData } from "../../entities/global";
import { getCoinEntityList, getCoinProfilesList } from "./thunks";
import { CoinEntity, CoinProfile } from "../../entities/coinGame";

interface CoinFlipState {
  loading: boolean;
  needUpdateEntites: boolean;
  needUpdateProfiles: boolean;
  entities: CoinEntity[];
  profiles: CoinProfile[];
  metaEntities: ResponseMetaData;
  metaProfiles: ResponseMetaData;
}

const initialState: CoinFlipState = {
  loading: false,
  needUpdateEntites: true,
  needUpdateProfiles: true,
  entities: [],
  profiles: [],
  metaEntities: {
    limit: 250,
    page: 1,
    pages: 1,
    total: 0,
  },
  metaProfiles: {
    limit: 250,
    page: 1,
    pages: 1,
    total: 0,
  }
};

export const coinFlipTableSlice = createSlice({
  name: "coinFlipTable",
  initialState,
  reducers: {
    handlerNeedUpdate: (state: Draft<CoinFlipState>) => {
      state.needUpdateEntites = true;
    },
    handlerNeedUpdateProfiles: (state: Draft<CoinFlipState>) => {
      state.needUpdateProfiles = true;
    },
  },
  extraReducers: (builder) => {
    // getCoinEntityList - получение списка игр
    builder.addCase(getCoinEntityList.pending, (state) => {
      state.loading = true;
      state.needUpdateEntites = false;
    });
    builder.addCase(getCoinEntityList.fulfilled, (state, action) => {
      const { data, ...meta } = action.payload
      state.entities = data;
      state.metaEntities = meta;
      state.loading = false;
    });
    // getCoinProfilesList
    builder.addCase(getCoinProfilesList.pending, (state) => {
      state.loading = true;
      state.needUpdateProfiles = false;
    });
    builder.addCase(getCoinProfilesList.fulfilled, (state, action) => {
      const { data, ...meta } = action.payload
      state.profiles = data;
      state.metaProfiles = meta;
      state.loading = false;
    });
  },
});
// export actions
export const { handlerNeedUpdate, handlerNeedUpdateProfiles } = coinFlipTableSlice.actions;

export default coinFlipTableSlice.reducer;
